<template>
  <div class="adContainer">
    <div
      :id="leftAdId"
      class="ad"
    />
    <div
      :id="rightAdId"
      class="ad"
    />
  </div>
</template>

<script setup>
defineProps({
  leftAdId: {
    type: String,
    required: true
  },
  rightAdId: {
    type: String,
    required: true
  }
})
</script>

<style scoped>
.adContainer {
  display: flex;
  justify-content: space-evenly;
}

.ad {
  width: 336px;
  min-height: 280px;
}
</style>
